module.exports = __webpack_public_path__ + "img/ground-mountain-night.d8cca4d2.png";